export default "__VITE_ASSET__CW$5Z1YW__"